// Custom CTA - UpStart - contact dealer
const mockVendorsCtaConfig1 = {
  __type: 'aem-headless',
  contentPath:
    '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/fa-vdp-pricing-bar-latest',
  fields: {
    vendorCtaGroup: {
      id: '9680a9ca-aa96-4b8d-9ffe-f375844efd2c',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:18:30.091Z',
      modified: '2025-06-25T18:01:43.987Z',
      title: 'pricing-bar-vendor-ctas-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3Rhcy1zaW5nbGVwb3NpdGlvbnNmb3J2ZHA',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-ctas-singlepositionsforvdp',
        title: 'Vendor CTAs Single Positions for VDP',
        metadata: {},
      },
      fields: {
        singlePositionVendorCTAs: [
          {
            id: '506b1b7e-4613-4477-b642-6bc08444aaf4',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/contact-dealer-test-latest-ali',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/contact-dealer-test-latest-ali',
            status: 'DRAFT',
            created: '2025-06-25T18:01:41.870Z',
            modified: '2025-06-25T18:01:52.243Z',
            title: 'contact dealer test latest ali',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jb250YWN0LWRlYWxlci1jdGFmb3J2ZHA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/contact-dealer-ctaforvdp',
              title: 'Contact Dealer CTA for VDP',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaDealerId: '25A70',
            },
          },
          {
            id: '64538ee3-f121-4bd4-b17c-8e461c8d60bc',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-upstart-latest',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-upstart-latest',
            status: 'DRAFT',
            created: '2025-02-13T22:18:54.603Z',
            modified: '2025-02-13T22:19:02.355Z',
            title: 'pricing-bar-vendor-upstart-latest',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3RhLWZvci12ZHB1cHN0YXJ0',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-cta-for-vdpupstart',
              title: 'Vendor CTA for VDP - Upstart',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              configTypeLocationUpstart: 'vdp',
            },
          },
          {
            id: '5283c9eb-5933-4c31-aea6-e4a53e5b5ddf',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-custom-latest',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-custom-latest',
            status: 'DRAFT',
            created: '2025-02-13T22:19:27.476Z',
            modified: '2025-06-25T17:57:54.116Z',
            title: 'pricing-bar-vendor-custom-latest',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jdXN0b20tdmVuZG9yLWN0YWZvcnZkcA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/custom-vendor-ctaforvdp',
              title: 'Custom Vendor CTA for VDP',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaVendorLink: '#',
              ctaVendorTarget: '_blank',
              ctaVendorButtonLabel: 'Custom CTA',
              ctaVendorAdditionalClasses: 'add-class-test',
              ctaVendorCustomId: 'custom-id',
            },
          },
        ],
      },
    },
    priceConfigModel: {
      id: 'f9a7fd20-5c9e-4a29-bead-63c75edbad19',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:16:55.196Z',
      modified: '2025-02-13T22:17:24.838Z',
      title: 'vdp-pricing-bar-config-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9wcmljZS1jb25maWctdmRwcHJpY2luZ2Jhcg',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/price-config-vdppricingbar',
        title: 'Price Config - VDP Pricing Bar',
        metadata: {},
      },
      fields: {
        mainPriceKey: 'regular',
        mainPriceLabel: 'Regular',
        secondPriceKey: 'final',
        secondPriceLabel: 'Final ',
        usedRetailLabel: 'Retail',
      },
    },
  },
  model: {
    path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/fa-vdp-pricing-bar',
    title: 'fa-vdp-pricing-bar',
    metadata: {
      baseUrl: 'https://fa-vdp-pricing-bar.cdn.prod.collab.apps.one.audi/v3.4.5',
      id: 'fec3625d-9c6e-40c2-b4ed-0ef127ecb709',
      serverSrc: '',
      src: 'fh/app.js',
    },
  },
};

// Contact Dealer - Custom CTA - VIN RECALL CTA
const mockVendorsCtaConfig2 = {
  __type: 'aem-headless',
  contentPath:
    '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/fa-vdp-pricing-bar-latest',
  fields: {
    vendorCtaGroup: {
      id: '9680a9ca-aa96-4b8d-9ffe-f375844efd2c',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:18:30.091Z',
      modified: '2025-06-25T18:01:43.987Z',
      title: 'pricing-bar-vendor-ctas-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3Rhcy1zaW5nbGVwb3NpdGlvbnNmb3J2ZHA',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-ctas-singlepositionsforvdp',
        title: 'Vendor CTAs Single Positions for VDP',
        metadata: {},
      },
      fields: {
        singlePositionVendorCTAs: [
          {
            id: '506b1b7e-4613-4477-b642-6bc08444aaf4',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/contact-dealer-test-latest-ali',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/contact-dealer-test-latest-ali',
            status: 'DRAFT',
            created: '2025-06-25T18:01:41.870Z',
            modified: '2025-06-25T18:01:52.243Z',
            title: 'contact dealer test latest ali',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jb250YWN0LWRlYWxlci1jdGFmb3J2ZHA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/contact-dealer-ctaforvdp',
              title: 'Contact Dealer CTA for VDP',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaDealerId: '25A70',
            },
          },
          {
            id: '5283c9eb-5933-4c31-aea6-e4a53e5b5ddf',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-custom-latest',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-custom-latest',
            status: 'DRAFT',
            created: '2025-02-13T22:19:27.476Z',
            modified: '2025-06-25T17:57:54.116Z',
            title: 'pricing-bar-vendor-custom-latest',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jdXN0b20tdmVuZG9yLWN0YWZvcnZkcA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/custom-vendor-ctaforvdp',
              title: 'Custom Vendor CTA for VDP',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaVendorLink: '#',
              ctaVendorTarget: '_blank',
              ctaVendorButtonLabel: 'Custom CTA',
              ctaVendorAdditionalClasses: 'add-class-test',
              ctaVendorCustomId: 'custom-id',
            },
          },
          {
            id: '5283c9eb-5933-4c31-aea6-e4a53aaa5ddc',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-vin-recall-latest',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-vin-recall-latest',
            status: 'DRAFT',
            created: '2025-02-13T22:19:27.476Z',
            modified: '2025-06-25T17:57:54.116Z',
            title: 'pricing-bar-vendor-vin-recall-latest',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jdXN0b20tdmVuZG9yLWN0YWZvcnZkcA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vin-recall-cta',
              title: 'Vin Recall CTA',
              metadata: {},
            },
            fields: {
              vinRecallLabel: 'NHTSA VIN Look up',
              vinRecallTypeVisibility: 'cpo',
              isVendorCtaEnabled: true,
            },
          },
        ],
      },
    },
    priceConfigModel: {
      id: 'f9a7fd20-5c9e-4a29-bead-63c75edbad19',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:16:55.196Z',
      modified: '2025-02-13T22:17:24.838Z',
      title: 'vdp-pricing-bar-config-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9wcmljZS1jb25maWctdmRwcHJpY2luZ2Jhcg',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/price-config-vdppricingbar',
        title: 'Price Config - VDP Pricing Bar',
        metadata: {},
      },
      fields: {
        mainPriceKey: 'regular',
        mainPriceLabel: 'Regular',
        secondPriceKey: 'final',
        secondPriceLabel: 'Final ',
        usedRetailLabel: 'Retail',
      },
    },
  },
  model: {
    path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/fa-vdp-pricing-bar',
    title: 'fa-vdp-pricing-bar',
    metadata: {
      baseUrl: 'https://fa-vdp-pricing-bar.cdn.prod.collab.apps.one.audi/v3.4.5',
      id: 'fec3625d-9c6e-40c2-b4ed-0ef127ecb709',
      serverSrc: '',
      src: 'fh/app.js',
    },
  },
};

// darwin - carNow - Gubagoo
const mockVendorsCtaConfig3 = {
  __type: 'aem-headless',
  contentPath:
    '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/fa-vdp-pricing-bar-latest',
  fields: {
    vendorCtaGroup: {
      id: '9680a9ca-aa96-4b8d-9ffe-f375844efd2c',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/pricing-bar-vendor-ctas-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:18:30.091Z',
      modified: '2025-06-25T18:11:26.950Z',
      title: 'pricing-bar-vendor-ctas-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3Rhcy1zaW5nbGVwb3NpdGlvbnNmb3J2ZHA',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-ctas-singlepositionsforvdp',
        title: 'Vendor CTAs Single Positions for VDP',
        metadata: {},
      },
      fields: {
        singlePositionVendorCTAs: [
          {
            id: '6185418d-b069-4f35-bd9f-826e17729d0d',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/latest-darwin-cta-test-ali',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/latest-darwin-cta-test-ali',
            status: 'DRAFT',
            created: '2025-06-25T18:06:44.662Z',
            modified: '2025-06-25T18:06:51.892Z',
            title: 'latest darwin cta test ali',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3RhLWRhcndpbg',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-cta-darwin',
              title: 'Vendor CTA - Darwin',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              configTypeLocationDarwin: 'vdp',
            },
          },
          {
            id: 'ae8f047b-10ae-4113-8621-3c0071bd3f7c',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/car-now-cta-latest-test-ali',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/car-now-cta-latest-test-ali',
            status: 'DRAFT',
            created: '2025-06-25T18:10:14.124Z',
            modified: '2025-06-25T18:10:19.965Z',
            title: 'car now cta latest test ali',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3RhLWZvci12ZHBjYXJub3c',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-cta-for-vdpcarnow',
              title: 'Vendor CTA for VDP - Carnow',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              pagePlacementTypeCarnow: 'vdp',
            },
          },
          {
            id: '6ba321fb-a4f4-40f1-8549-7f674d974768',
            path: '/narshop/ali-test/latest-vlp/inventory/vehicle/gubagoo-cta-latest-test-ali',
            contentPath:
              '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/gubagoo-cta-latest-test-ali',
            status: 'DRAFT',
            created: '2025-06-25T18:11:24.806Z',
            modified: '2025-06-25T18:11:47.246Z',
            title: 'Gubagoo cta latest test ali',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3RhLWZvci12ZHBndWJhZ29v',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-cta-for-vdpgubagoo',
              title: 'Vendor CTA for VDP - Gubagoo',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              flowOptionGubagoo: 'payments',
              ctaGubagooLabel: 'Gubagoo custom label',
            },
          },
        ],
      },
    },
    priceConfigModel: {
      id: 'f9a7fd20-5c9e-4a29-bead-63c75edbad19',
      path: '/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      contentPath:
        '/content/dam/teams/narshop/ali-test/latest-vlp/inventory/vehicle/vdp-pricing-bar-config-latest',
      status: 'DRAFT',
      created: '2025-02-13T22:16:55.196Z',
      modified: '2025-02-13T22:17:24.838Z',
      title: 'vdp-pricing-bar-config-latest',
      description: '',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9wcmljZS1jb25maWctdmRwcHJpY2luZ2Jhcg',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/price-config-vdppricingbar',
        title: 'Price Config - VDP Pricing Bar',
        metadata: {},
      },
      fields: {
        mainPriceKey: 'regular',
        mainPriceLabel: 'Regular',
        secondPriceKey: 'final',
        secondPriceLabel: 'Final ',
        usedRetailLabel: 'Retail',
      },
    },
  },
  model: {
    path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/fa-vdp-pricing-bar',
    title: 'fa-vdp-pricing-bar',
    metadata: {
      baseUrl: 'https://fa-vdp-pricing-bar.cdn.prod.collab.apps.one.audi/v3.4.5',
      id: 'fec3625d-9c6e-40c2-b4ed-0ef127ecb709',
      serverSrc: '',
      src: 'fh/app.js',
    },
  },
};

const mockVendorsCtaConfig4 = {
  __type: 'aem-headless',
  contentPath: '/content/dam/oadd/us/03c55/en/inventory/vehicle/fa-vdp-pricing-bar',
  fields: {
    vendorCtaGroup: {
      id: '0971d1c9-d4ef-4f9f-bffa-665ffac23199',
      path: '/en/configurations/inventory/fa-vdp-pricing-bar-cta',
      contentPath: '/content/dam/oadd/us/03c55/en/configurations/inventory/fa-vdp-pricing-bar-cta',
      title: 'FA | VDP Pricing Bar > CTA',
      description: '.',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3Rhcy1zaW5nbGVwb3NpdGlvbnNmb3J2ZHA',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-ctas-singlepositionsforvdp',
        title: 'Vendor CTAs Single Positions for VDP',
        metadata: {},
      },
      fields: {
        singlePositionVendorCTAs: [
          {
            id: '3659c76c-e281-4c12-9f69-e4690965eb2e',
            path: '/en/configurations/inventory/fa-vdp-pricing-bar-cta-value-your-trade',
            contentPath:
              '/content/dam/oadd/us/03c55/en/configurations/inventory/fa-vdp-pricing-bar-cta-value-your-trade',
            title: 'FA | VDP Pricing Bar > CTA > Start Buying Process',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9jdXN0b20tdmVuZG9yLWN0YWZvcnZkcA',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/custom-vendor-ctaforvdp',
              title: 'Custom Vendor CTA for VDP',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaVendorLink: 'https://express.audinovi.com/express/',
              ctaVendorTarget: '_self',
              ctaVendorButtonLabel: 'Start Buying Process',
            },
          },
          {
            id: 'fc00e61a-6972-42b5-a2fd-e96eeabe6f51',
            path: '/en/configurations/inventory/fa-vdp-pricing-bar-cta-roadster',
            contentPath:
              '/content/dam/oadd/us/03c55/en/configurations/inventory/fa-vdp-pricing-bar-cta-roadster',
            title: 'FA | VDP Pricing Bar > CTA > Roadster',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92ZW5kb3ItY3RhLWZvci12ZHByb2Fkc3Rlcg',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vendor-cta-for-vdproadster',
              title: 'Vendor CTA for VDP - Roadster',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              ctaRoadsterUrl: 'https://express.audinovi.com/express/',
              actionTypeRoadster: 'See payment options',
              ctaRoadsterLabelEnglish: 'english label',
              ctaRoadsterLabelFrench: 'étiquette française',
            },
          },
          {
            id: 'b0bbe721-97f9-43aa-8935-299ad633cc2a',
            path: '/en/configurations/inventory/fa---vdp-pricing-bar->-cta->-vin-recall-cta',
            contentPath:
              '/content/dam/oadd/us/03c55/en/configurations/inventory/fa---vdp-pricing-bar->-cta->-vin-recall-cta',
            title: 'FA | VDP Pricing Bar > CTA > Vin Recall CTA',
            description: '',
            model: {
              id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy92aW4tcmVjYWxsLWN0YQ',
              path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/vin-recall-cta',
              title: 'Vin Recall CTA',
              metadata: {},
            },
            fields: {
              isVendorCtaEnabled: true,
              vinRecallLabel: 'NHTSA VIN Look up',
              vinRecallTypeVisibility: 'cpo',
            },
          },
        ],
      },
    },
    priceConfigModel: {
      id: 'dd57b05f-8fbe-41a4-b64a-978de3c9f933',
      path: '/en/configurations/inventory/fa-vdp-pricing-bar-price-breakdown',
      contentPath:
        '/content/dam/oadd/us/03c55/en/configurations/inventory/fa-vdp-pricing-bar-price-breakdown',
      title: 'FA | VDP Pricing Bar > Price breakdown',
      description: '.',
      model: {
        id: 'L2NvbmYvZmVhdHVyZS1hcHBzL29uZWF1ZGktZmVhdHVyZS1hcHAtdmRwLXByaWNpbmctYmFyL2xhdGVzdC9zZXR0aW5ncy9kYW0vY2ZtL21vZGVscy9wcmljZS1jb25maWctdmRwcHJpY2luZ2Jhcg',
        path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/price-config-vdppricingbar',
        title: 'Price Config - VDP Pricing Bar',
        metadata: {},
      },
      fields: {
        mainPriceKey: 'regular',
        mainPriceLabel: 'Price',
        textOverrideMain: 'Arriving Soon',
        textOverrideSecond: 'Arriving Soon',
        secondPriceKey: 'final',
        secondPriceLabel: 'Total MSRP',
        secondShortDisclaimer: 'Dealer Sets Actual Price',
        secondLongDisclaimer:
          'Total MSRP includes destination ($1,095 for sedans, $1,195 for SUVs incl. Sportbacks, and $1,495 for the R8 and e-tron GT). Total MSRP excludes taxes, title, other options, and dealer charges and fees. Dealer sets actual price. May vary from MSRP.',
        usedRetailLabel: 'Price',
        mainPriceKeyUsed: 'retail',
      },
    },
  },
  model: {
    path: '/conf/feature-apps/oneaudi-feature-app-vdp-pricing-bar/latest/settings/dam/cfm/models/fa-vdp-pricing-bar',
    title: 'fa-vdp-pricing-bar',
    metadata: {
      baseUrl: 'https://fa-vdp-pricing-bar.cdn.prod.collab.apps.one.audi/v3.6.7',
      id: 'fec3625d-9c6e-40c2-b4ed-0ef127ecb709',
      serverSrc: '',
      src: 'fh/app.js',
    },
  },
};

export const getMockContent = (select: number) => {
  if (select === 1) {
    return mockVendorsCtaConfig1;
  }
  if (select === 2) {
    return mockVendorsCtaConfig2;
  }
  if (select === 3) {
    return mockVendorsCtaConfig3;
  }
  if (select === 4) {
    return mockVendorsCtaConfig4;
  }
  return mockVendorsCtaConfig1;
};
